import { ResourceInfoProvider } from '@openx/components-core/lib/Form/context/ResourceInfoContext';
import type { DealDetailsSectionProps } from '../../types';
import type { DetailsTabDeal } from './DealDetailsTab';
import { CuratedDealFeesDetailsSection } from './sections/CuratedDealFeesSection/CuratedDealFeesDetailsSection';
import { DealDetailsSection } from './sections/DealDetailsSection/DealDetailsSection';
import { DealFloorAndDurationSection } from './sections/DealFloorAndDurationSection';
import { IdsDetailsSection } from './sections/IdsDetailsSection';
import { TargetingCriteriaDetailsSection } from './sections/TargetingCriteriaDetailsSection';

export const DirectDealDetailsTab = <T extends DetailsTabDeal = DetailsTabDeal>({
  deal,
  historyMode,
}: DealDetailsSectionProps<T>) => {
  return (
    <ResourceInfoProvider name="deal">
      <IdsDetailsSection<T> deal={deal} historyMode={historyMode} />

      <DealDetailsSection<T> deal={deal} historyMode={historyMode} />

      <DealFloorAndDurationSection<T> deal={deal} historyMode={historyMode} />

      <CuratedDealFeesDetailsSection<T> deal={deal} historyMode={historyMode} />

      <TargetingCriteriaDetailsSection<T> deal={deal} historyMode={historyMode} />
    </ResourceInfoProvider>
  );
};
